export const orderData = {
  customer: {},
  trip: {},
  returnTrip: false,
  returnTripTime: null,
  selectedCars: null,
  totalTripPrice: 0,
  totalOrderPrice: 0,
  currency: null,
  infoForDriver: {},

  tripExtras: {
    passengers: null,
    luggageUnits: 0,
    childSeats: { infant: 0, child: 0, booster: 0 },
    seatsEnabled: false,
  },
};

// =====================================
// Функції для оновлення order
// =====================================
export const setCustomerOrderData = customerData => {
  Object.assign(orderData.customer, customerData);
};

export const setTripOrderData = tripData => {
  Object.assign(orderData.trip, tripData);
};

export const setSelectedCarsOrderData = cars => {
  orderData.selectedCars = cars;
};

export const setPriceOrderData = priceData => {
  Object.assign(orderData, priceData);
};

export const setInfoForDriverOrderData = info => {
  Object.assign(orderData.infoForDriver, info);
};

export const setReturnTripOrderData = data => {
  Object.assign(orderData, data);
};

export const setTripExtrasOrderData = extras => {
  Object.assign(orderData.tripExtras, extras);
};
